import mastercardimg from "assets/images/icons/icons8-mastercard-logo.svg"
import visacardimg from "assets/images/icons/icons8-visa.svg"
import amexcardimg from "assets/images/icons/icons8-american-express.svg"
import { DEFAULT_CONVENIENCE_FEE_PERCENTAGE } from "./sf_constants"

export const iconForCardType = (billing_setting) => {
    if (billing_setting?.card_brand === 'visa'){
        return <img className="me-2" src={visacardimg} />
    } if (billing_setting?.card_brand === 'mastercard'){
        return <img className="me-2" src={mastercardimg} /> 
    } if (billing_setting?.card_brand === 'amex'){
        return <img className="me-2" src={amexcardimg} />
    }
}

export const convenienceFeeNote = (percentage = DEFAULT_CONVENIENCE_FEE_PERCENTAGE) => {
    return `Note: A ${percentage}% convenience fee will be applied to all credit and debit card payments.`
 }

